import React from "react";
import { useNavigate } from "react-router-dom";

const AnnouncementCard = ({ announcement }) => {
  const navigate = useNavigate();
  const hasImage = announcement.hasImage && announcement.imageUrl;

  const handleReadMore = () => {
    // Navigate to announcement detail page with announcement data
    navigate('/host/announcement-detail', { 
      state: { announcement } 
    });
  };

  return (
    <div className="announcement-card mb-4" style={{ padding: "5% 10%" }}>
      <div className="d-flex justify-content-between align-items-start mb-3">
        <h2
          className="announcement-title mb-0"
          style={{ fontWeight: 700, fontSize: "1.35rem", color: "#222" }}
        >
          {announcement.title}
        </h2>
        <span
          className="announcement-date"
          style={{ fontSize: "1rem", fontWeight: 500 }}
        >
          {announcement.date}
        </span>
      </div>
      <div
        className={`row g-0 announcement-content align-items-stretch${
          hasImage ? "" : " flex-column"
        }`}
        style={{ minHeight: hasImage ? 250 : "auto" }}
      >
        {hasImage && (
          <div
            className="col-12 col-md-7 me-5 order-1 order-md-1"
            style={{ maxWidth: "55%" }}
          >
            <div
              className="announcement-image-container w-100"
              style={{
                position: "relative",
                width: "100%",
                height: "100%",
                overflow: "hidden",
              }}
            >
              <img
                src={announcement.imageUrl || "/placeholder.svg"}
                alt="Announcement"
                className="announcement-image img-fluid"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </div>
          </div>
        )}
        <div
          className={
            hasImage
              ? "col-12 col-md-5 d-flex flex-column justify-content-between order-2 order-md-2"
              : "col-12 d-flex flex-column justify-content-between"
          }
          style={
            hasImage
              ? { minHeight: 250, flex: "0 0 40%", maxWidth: "40%" }
              : { minHeight: 250 }
          }
        >
          <div className="flex-grow-1">
            <p
              className="announcement-description text-muted mb-3"
              style={{
                fontSize: "1rem",
                color: "#666",
                maxHeight: "10vh",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
              }}
            >
              {announcement.content}
            </p>
          </div>
          <div
            className={hasImage ? "w-100" : "d-flex justify-content-end w-100"}
            style={{ minWidth: "100%" }}
          >
            <button
              className={
                hasImage ? "btn read-more-btn w-100" : "btn read-more-btn"
              }
              style={{
                background: "#FF00FE",
                color: "#fff",
                fontWeight: 600,
                padding: "24px 48px",
                borderRadius: 8,
                fontSize: "1rem",
                textTransform: "uppercase",
                letterSpacing: 0.5,
                width: hasImage ? "100%" : "40%",
              }}
              onClick={handleReadMore}
            >
              READ MORE
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementCard;